import icon from 'assets/img/icons/success-green-big.svg'
import {useLocation, useNavigate } from 'react-router-dom'

const PurchaseWindowSuccess = ({ currentQuantity, close, cardPackId = 0 }) => {
  const navigate = useNavigate();
  const {pathname} = useLocation();

  const confrimSuccess = () => {
    close();
  }

  const lookAtPacks = () => {
    close();
    navigate(`/inventory/card-packs`)
  }

  const openPacks = () => {
    close();
    navigate(`/inventory/card-pack-open/${cardPackId}`);
  }

  const getPackAction = () => {
    if (pathname.includes('buypacks')) {
      if (currentQuantity === 1) {
        return <button className="modal-window__footer-close modal-window__footer-close--by-open" onClick={openPacks}>Open Pack</button>
      } else if(currentQuantity > 1) {
        return <button className="modal-window__footer-close" onClick={lookAtPacks}>Card Packs</button>
      }
    }
  }

  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Success!</h5>
        <p className="modal-window__info">Your transaction was completed.</p>
      </header>
      <footer className="modal-window__footer">
        {getPackAction()}

        <button className="modal-window__footer-submit" onClick={confrimSuccess}>Done</button>
      </footer>
    </>
  )
}

export default PurchaseWindowSuccess;
